import React, { FC } from 'react' // Added React import
import { useIntl } from 'react-intl'
// Import the correct component and its interface
import PaymentReportTableRow, { IMonthlyPaymentItem } from './PaymentReportTableRow' 
// Removed local interface definition

// Update props to include the callback and use the imported interface
interface IProps {
    data: IMonthlyPaymentItem[];
    onOpenUploadModal: (item: IMonthlyPaymentItem) => void; // Add callback prop
}

// Rename the component to match the filename
const PaymentReportTable: FC<IProps> = ({ data, onOpenUploadModal }) => { // Destructure the new prop
    const { formatMessage } = useIntl()

    return (
        <>
            {/* Adjusted table classes for styling if needed, kept original for now */}
            <table className='table align-middle gs-0 gy-4'> 
                <thead>
                    <tr className='fw-bold text-muted bg-light'>
                        <th className='ps-4 min-w-125px rounded-start'>{formatMessage({ id: 'payment_period' })}</th>
                        <th className='min-w-125px rounded-start'>{formatMessage({ id: 'amount' })}</th>
                        <th className='min-w-125px rounded-start'>{formatMessage({ id: 'status' })}</th>
                        <th className='min-w-150px rounded-end'>{formatMessage({ id: 'actions' })}</th>
                    </tr>
                </thead>
                <tbody>
                {data && data.length > 0 ? ( // Check if data exists and is not empty
                    data.map((item) => ( 
                        // Use the correct component and pass the required props
                        <PaymentReportTableRow 
                            key={item.supplier_payment_id} // Use unique ID from the interface
                            item={item} 
                            onOpenUploadModal={onOpenUploadModal} // Pass the callback down
                        />
                    ))
                ) : (
                    <tr>
                        <td colSpan={4} className='text-center'> {/* Adjust colSpan */}
                            {formatMessage({ id: 'No data available' })} {/* Add a message for no data */}
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
        </>
    )
}

// Export the renamed component
export default PaymentReportTable
